var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11036_95845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "#FABE2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 3.59894 12.401 0 8 0V16C12.401 16 16 12.401 16 8Z",
    fill: "#FF9100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 14.0938C11.3655 14.0938 14.0938 11.3655 14.0938 8C14.0938 4.63451 11.3655 1.90625 8 1.90625C4.63451 1.90625 1.90625 4.63451 1.90625 8C1.90625 11.3655 4.63451 14.0938 8 14.0938Z",
    fill: "#FED843"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0938 8C14.0938 4.64 11.36 1.90625 8 1.90625V14.0938C11.36 14.0938 14.0938 11.36 14.0938 8Z",
    fill: "#FABE2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0123 6.69573C11.9569 6.52588 11.8104 6.40229 11.6337 6.37666L9.41356 6.05395L8.42021 4.04207C8.34146 3.88185 8.17075 3.80176 8 3.80176C7.82925 3.80176 7.6585 3.88185 7.57978 4.04207L6.58643 6.05395L4.36628 6.37666C4.18959 6.40229 4.04309 6.52588 3.98771 6.69526C3.93278 6.8651 3.97856 7.05138 4.10628 7.17591L5.71303 8.74238L5.334 10.9539C5.30378 11.1296 5.37612 11.3073 5.52031 11.4121C5.66593 11.5178 5.85762 11.5306 6.01378 11.4478L7.99996 10.4041L9.98621 11.4478C10.1437 11.5311 10.3359 11.5178 10.4797 11.412C10.6239 11.3072 10.6962 11.1296 10.666 10.9538L10.2865 8.74235L11.8937 7.17588C12.0214 7.05141 12.0672 6.8651 12.0123 6.69573Z",
    fill: "#FABE2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4797 11.4121C10.6239 11.3073 10.6962 11.1296 10.666 10.9539L10.2865 8.74238L11.8937 7.17591C12.0214 7.05141 12.0672 6.8651 12.0123 6.69573C11.9569 6.52588 11.8104 6.40229 11.6337 6.37666L9.41356 6.05395L8.42022 4.04207C8.34147 3.88185 8.17075 3.80176 8 3.80176V10.4041L9.98625 11.4478C10.1437 11.5311 10.3359 11.5178 10.4797 11.4121Z",
    fill: "#FF9100"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11036_95845"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/Coin.c355a8a7321af1cc374693325c9dda45.svg";
export { ForwardRef as ReactComponent };